import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import { useNavMenu } from '../../../providers/NavMenu.provider';
import styles from './LearningCenter.module.scss';
import { useTranslation } from 'react-i18next';

type FC = FunctionComponent;

const { Box, Title, Icon } = vp;
const environment = import.meta.env.VITE_APP_ENV;
const cn = vp.withStyles(styles);

const LearningCenterContainer: FC = () => {
  const history = useHistory();
  const { getModuleTitle } = useNavMenu();
  const { t } = useTranslation('translations', { keyPrefix: 'LearningCentre' });

  return (
    <Box flx="col">
      <Box mb="md" jc="sb">
        <Title title={getModuleTitle()} />
      </Box>
      <Box mt="md" lineHeight="25px">
        {t('subTitle')}
      </Box>
      <div className={cn('cardContainer')}>
        <div
          className={cn('card', 'faqCard')}
          onClick={() => {
            history.push('/faq');
          }}
        >
          <div className={cn('iconContainer')}>
            <Icon icon="faq3" color="none" width="50px" height="50px" />
          </div>
          <h4>{t('faqBlock')}</h4>
        </div>
        <div
          className={cn('card', 'devDocsCard')}
          onClick={() => {
            window.open('/docs?redirect=/', '_blank');
          }}
        >
          <div className={cn('iconContainer')}>
            <Icon icon="developerDoc" color="none" width="50px" height="50px" />
          </div>
          <h4>{t('devDocsBlock')}</h4>
        </div>
        <div
          className={cn('card', 'videoCard', environment === 'staging' && 'inactiveCard')}
          onClick={() => {
            history.push('/learning-centre/video-tutorials/');
          }}
        >
          {environment === 'staging' && <span className={cn('label')}>{t('productionOnlyTag')}</span>}
          <div className={cn('iconContainer')}>
            <Icon icon="video" color="none" width="50px" height="50px" />
          </div>
          <h4>{t('videoTutorialsBlock')}</h4>
        </div>
        <div
          className={cn('card', 'pdfCard', environment === 'staging' && 'inactiveCard')}
          onClick={() => {
            history.push('/learning-centre/pdf-guide/');
          }}
        >
          {environment === 'staging' && <span className={cn('label')}>{t('productionOnlyTag')}</span>}
          <div className={cn('iconContainer')}>
            <Icon icon="pdfActive" color="none" width="50px" height="50px" />
          </div>
          <h4>{t('PDFGuideBlock')}</h4>
        </div>
      </div>
    </Box>
  );
};

export default LearningCenterContainer;
